import React from "react";
import "../Styles/Home.css";

function Header() {
  return (
    <>
      <section className="dialog-section">
        <div style={{ display: "flex", alignItems: "center" }}>
          <h1 style={{ marginRight: "10px", textAlign: "left" }}>DiaBrain</h1>
        </div>
      </section>
    </>
  );
}

export default Header;
